import { Link } from "react-router-dom";
import { Button } from "@carbon/react";

import { Checkbox, Select, TextInput } from "../../ui";
import {  FormContainer } from "../../components";

import switchAppLogo from "../../assets/icons/switchapp-logo.svg";
import bulletIcon from "../../assets/icons/bullet.svg";

export const View = () => {
  return (
    <div className="signup-page--container flex-container col justify-content--center align-items--center">
      <div className="flex-container align-items--center">
        <div className="marketting-container">
          <div className="logo-container">
            <img src={switchAppLogo} alt="logo" />
          </div>

          <div className="marketting-text">
           
              icon={<img src={bulletIcon} alt="bullet point icon" />}
              title="Get started quickly"
              description="Integrate with developer-friendly APIs or choose low-code or pre-built solutions."
            

            
              icon={<img src={bulletIcon} alt="bullet point icon" />}
              title="Support any business model"
              description="E-commerce, subscriptions, SaaS platforms, marketplaces, and more—all within a unified platform."
            

          
              icon={<img src={bulletIcon} alt="bullet point icon" />}
              title="Join other businesses"
              description="SwitchApp is trusted by ambitious startups and enterprises of every size."
          
          </div>
        </div>

        <FormContainer>
          <div className="form-container flex-container col">
            <div className="form-container__header font-ctm--bold">
              <h3>Sign Up</h3>
            </div>

            <div className="form-container__body">
              <div className="flex-container flex-break--small">
                <div className="flex-box mr-5">
                  <TextInput label="First Name" />
                </div>
                <div className="flex-box">
                  <TextInput label="Last Name" />
                </div>
              </div>
              <TextInput label="Email" />
              <TextInput label="Company Name" />

              <Select label="Country" />

              <div className="flex-container flex-break--small">
                <div className="flex-box mr-5">
                  <TextInput label="Password" />
                </div>
                <div className="flex-box">
                  <TextInput label="Confirm Password" />
                </div>
              </div>

              <Checkbox label="I agree that Switch App may contact me at the email address or phone number above." />

              <div className="flex-container buttons-container">
                <Button className="flex-box switchapp-themed">
                  Create Merchant Account
                </Button>
              </div>
            </div>
          </div>

          <div className="form-container__footer">
            <p className="switchapp-small">
              Already have an account? <Link to={"/signin"}>Sign In</Link>
            </p>
          </div>

         

          <div className="flex-box switchapp-legal-agreements switchapp-small form-container__footer">
            By activating your profile you agree with the{" "}
            <Link to="/terms-of-service">Terms and Conditions</Link>,{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>
            <br className="line-break--small" />
            and <Link to="/cookie-policy">Cookie Policy</Link> of
            <b className="company-name font-ctm--bold">
              {" "}
              SwitchApp Tech Solutions Limited.
            </b>
          </div>
        </FormContainer>
      </div>
    </div>
  );
};
